import { render, staticRenderFns } from "./settle-contract.component.vue?vue&type=template&id=1c3a60fe&scoped=true"
import script from "./settle-contract.component.vue?vue&type=script&lang=ts"
export * from "./settle-contract.component.vue?vue&type=script&lang=ts"
import style0 from "./settle-contract.component.vue?vue&type=style&index=0&id=1c3a60fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a60fe",
  null
  
)

export default component.exports